import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectFromDeveloper = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('from_developer')(jsonQuery),
);
